import { useEffect, useState } from 'react';
import { useGetApiV1ExamDisciplineDropdownFiltered } from '@/shared/api/generated';

/**
 * Hook para carregar as opções de disciplina para o filtro do dashboard de correção.
 *
 * @param filter - Texto para busca server-side (mínimo 3 caracteres, debounce de 1 segundo)
 * @returns Lista de opções e estado de carregamento
 */
export function useDisciplineOptions(filter = '') {
  const [debouncedFilter, setDebouncedFilter] = useState('');

  useEffect(() => {
    if (filter === '') {
      setDebouncedFilter('');
      return;
    }
    const timer = setTimeout(() => setDebouncedFilter(filter), 1000);
    return () => clearTimeout(timer);
  }, [filter]);

  const isReady = debouncedFilter.length >= 3;
  const query = useGetApiV1ExamDisciplineDropdownFiltered(
    isReady ? { filter: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return {
    options: query.data ?? [],
    isLoading: query.isLoading,
    isQuerySuccess: query.isSuccess,
  } as const;
}
